import React, { Component } from "react";
import {
  FaTwitter,
  FaFacebookSquare,
  FaYoutube,
  FaInstagram,
  FaPhone,
} from "react-icons/fa";
import "./Footer.scss";
export default class Footer extends Component {
  render() {
    return (
      <footer className="footer-wrapper">
        <div className="container">
          <div className="footer-inquer">
            <FaPhone />
            <p>للاستفسار</p>
            <a href="tel:+920020310">920020310</a>
          </div>
          <div className="footer-copy">
            <p>جميع الحقوق محفوظة، شركة myCar © 2023</p>
          </div>
          <div className="footer-social">
            <a href="http://" target="_blank">
              <FaTwitter />
            </a>
            <a href="http://" target="_blank">
              <FaFacebookSquare />
            </a>
            <a href="http://" target="_blank">
              <FaYoutube />
            </a>
            <a href="http://" target="_blank">
              <FaInstagram />
            </a>
          </div>
        </div>
      </footer>
    );
  }
}
